var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"choose-widget"},_vm._l((_vm.input_data),function(item,index){return _c('div',{key:index,staticClass:"choose-item",class:{ active: _vm.selected_item == item.value },on:{"click":function($event){return _vm.selectItem(item.value)}}},[_vm._v(" "+_vm._s(_vm._f("validate")(item.name))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }